import { ImageLoader } from "~/components/ImageLoader";
import { Link } from "~/components/Link";
import {
    BlogPost,
    formatDate,
    getPostImage,
    urlFor,
} from "~/modules/blog/api/sanity";
import { BlogUserEvents } from "~/modules/analytics/events/blog";

// // // //

export function BlogListItem(props: { post: BlogPost }) {
    const { post } = props;
    const image = getPostImage(post);
    const date = formatDate(post.publishedAt || post._createdAt);

    return (
        <Link
            href={`/blog/${post.slug.current}`}
            className="flex h-full w-full flex-col rounded bg-card border p-6 text-sm leading-5 text-foreground shadow-[0_0_10px_-19px_#140d5d14]"
            analyticsLabel={BlogUserEvents.ClickListItem}
            analyticsEventProperties={{ slug: post.slug.current }}
        >
            <div className="mb-6 h-[310px] overflow-hidden rounded">
                <ImageLoader
                    src={image ? urlFor(image).width(800).url() : null}
                    alt={post.title}
                    className="h-full w-full object-contain"
                />
            </div>

            <div className="flex flex-1 flex-col items-start gap-4">
                {post.category && post.categoryLabel && (
                    <div
                        className="rounded-full px-3 py-0.5 text-sm font-semibold uppercase leading-6 tracking-[0.08em] text-foreground"
                        style={{ backgroundColor: post.categoryColor }}
                    >
                        <div>{post.categoryLabel}</div>
                    </div>
                )}

                <h6 className="text-2xl font-light leading-[1.4] text-foreground">
                    {post.title}
                </h6>

                <div className="mt-auto flex w-full flex-col items-start gap-4">
                    <div className="h-px w-full bg-border" />

                    <div className="flex flex-wrap items-center gap-2 text-xs">
                        <div className="whitespace-nowrap">{date}</div>
                        {post.readTime && (
                            <>
                                <div className="h-1 w-1 shrink-0 rounded-full bg-foreground" />
                                <div className="whitespace-nowrap">
                                    {post.readTime}
                                </div>
                            </>
                        )}
                        {post.author?.name && (
                            <>
                                <div className="h-1 w-1 shrink-0 rounded-full bg-foreground" />
                                <div className="whitespace-nowrap">
                                    {post.author.name}
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </Link>
    );
}
